// outage.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OutageService {
  private apiUrl = 'https://figpt.org/api/test';
  private statusSubject = new BehaviorSubject<'planned' | 'in-progress' | null>(null);

  status$ = this.statusSubject.asObservable();

  constructor(private http: HttpClient) {}

  /** Checks if the server is reachable */
  checkServerStatus(): void {
    this.http.get(this.apiUrl).pipe(
      catchError((err) => {
        console.log('Server is down.');
        this.statusSubject.next('in-progress');
        return of(null);
      })
    ).subscribe(response => {
      if (response !== null) {
        console.log('Successfully connected to Server.');
        this.statusSubject.next(null);
      }
    });
  }

  /** Allows components to manually trigger a status update */
  setStatus(status: 'planned' | 'in-progress' | null): void {
    this.statusSubject.next(status);
  }

  /** Dismiss the outage UI */
  dismiss(): void {
    this.statusSubject.next(null);
  }
}